import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import userReducer from "./auth/auth.slice";
import tempReducer from "./temp/temp-data.slice";
import globalSlice from "./global/global.slice";
import applicationReducer from "./application/application.slice";
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import RouterReducer from "./routes/routes.slice";

const persistConfig = {
	key: "root",
	storage,
	whitelist: ["currentUser", "tempData", "globalData", "application"],
};

const rootReducer = combineReducers({
	currentUser: userReducer,
	tempData: tempReducer,
	globalData: globalSlice,
	application: applicationReducer,
	router: RouterReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) => [
		...getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
	],
});

export const persistor = persistStore(store);
